import React, { useEffect, useState } from "react";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Checkbox,
  TextField,
  FormGroup,
  Box,
} from "@mui/material";
import { gridColumnVisibilityModelSelector } from "@mui/x-data-grid";

const EmergencyPlanningField = (props) => {
  const { formData = {}, onChange, idSchema, errorSchema = {}, schema } = props;
  const [touched, setTouched] = useState(false);

  const handlePriorityChange = (event) => {
    onChange({
      ...formData,
      priorityLevel: event.target.value,
    });
  };
  useEffect(() => {
    if (errorSchema?.stearRegistration?.__errors?.length > 0 && !touched) {
      setTouched(true); // show error if form is validated without touching
    }
  }, [errorSchema, touched]);
  const handleStearChange = (event) => {
    const checked = event.target.checked;
    setTouched(true);

    onChange({
      ...formData,
      stearRegistration: checked ? true : undefined,
      notes: checked ? formData.notes || "" : "",
    });
  };

  const handleNotesChange = (event) => {
    onChange({
      ...formData,
      notes: event.target.value,
    });
  };

  const notesError =
    errorSchema?.notes?.__errors?.length > 0
      ? errorSchema.notes.__errors[0]
      : null;
  const stearError =
    errorSchema?.stearRegistration?.__errors?.length > 0
      ? schema?.properties?.stearRegistration?.errorMessage?.required
      : null;
  return (
    <>
      <Typography variant="body2" gutterBottom>
        <strong>
          Texas Administrative Code TITLE 26, PART 1, RULE §558.256
        </strong>{" "}
        requires Cambridge Caregivers to categorize clients for emergency
        preparedness and response purposes.
      </Typography>

      <Box mt={2}>
        <FormLabel component="legend">
          Client Emergency Priority Level
        </FormLabel>
        <Typography variant="caption" gutterBottom>
          Select the appropriate urgency level based on the examples below
        </Typography>

        <RadioGroup
          name={`${idSchema.$id}_priorityLevel`}
          value={formData.priorityLevel || ""}
          onChange={handlePriorityChange}
        >
          <FormControlLabel
            value="High"
            control={<Radio />}
            label="High Priority - Client is dependent on electricity for life-sustaining equipment"
          />
          <FormControlLabel
            value="Medium"
            control={<Radio />}
            label="Medium Priority - Client has medical needs but not immediately life-threatening"
          />
          <FormControlLabel
            value="Low"
            control={<Radio />}
            label="Low Priority - Client is generally independent and mobile"
          />
        </RadioGroup>
      </Box>
      <FormGroup sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.stearRegistration || false}
              onChange={handleStearChange}
              onBlur={() => setTouched(true)}
            />
          }
          label={
            <Box>
              <Typography variant="body1">
                STEAR (State of Texas Emergency Assistance Registry)
              </Typography>
            </Box>
          }
          sx={{ alignItems: "flex-start" }}
        />
        {touched && stearError && (
          <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 4 }}>
            {stearError}
          </Typography>
        )}
      </FormGroup>

      
      <Box mt={2} p={2} bgcolor="#f8f9fa" borderRadius={1}>
        <Typography variant="body2">
          The STEAR program is a free registry that provides local emergency
          planners and emergency responders with additional information on the
          needs in their community. Texas communities use the registry
          information in different ways. Registering yourself in the STEAR
          registry DOES NOT guarantee that you will receive a specific service
          during an emergency. If you are not able to register for this free
          service, please reach out to care@cambridgecaregivers.com and a member
          of our team will support, alternatively you may dial 211 on a mobile
          device and register. I acknowledge that the STEAR registration details
          have been provided and understand that it is the client's
          responsibility to request assistance if needed.
        </Typography>
      </Box>
      {formData.stearRegistration && (
        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight={500}>
            Additional Notes
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={1}>
            Any additional information relevant to emergency planning
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={3}
            placeholder="Enter any special considerations or notes"
            value={formData.notes || ""}
            onChange={handleNotesChange}
            variant="outlined"
            error={!!notesError}
            helperText={notesError || ""}
          />
        </Box>
      )}
    </>
  );
};

export default EmergencyPlanningField;
